import styled from 'foundations-theming/utils';
const getHighlightBorder = theme => `border-right: ${theme.borderWidth['200']} solid ${theme.color['fill-info-default']};`;
export const ResizeAffordance = styled.div.withConfig({
  displayName: "ResizeAffordance",
  componentId: "sc-190gy19-0"
})(["inline-size:", ";block-size:100%;cursor:col-resize;", " &:hover{", "}"], ({
  theme
}) => theme.space['250'], ({
  $shouldHighlight,
  theme
}) => $shouldHighlight ? getHighlightBorder(theme) : '', ({
  theme
}) => getHighlightBorder(theme));